import { render } from "./LiquidityRatio.vue?vue&type=template&id=65d8e7ec&scoped=true"
import script from "./LiquidityRatio.vue?vue&type=script&lang=js"
export * from "./LiquidityRatio.vue?vue&type=script&lang=js"

import "./LiquidityRatio.vue?vue&type=style&index=0&id=65d8e7ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d8e7ec"]])

export default __exports__